export const products = [
  {
    id: 'p1',
    name: 'The Terra Flask',
    subtitle: '32oz | Triple-Wall Insulated',
    price: 42,
    category: 'bottles',
    collection: 'Core Series',
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?q=80&w=800&auto=format&fit=crop',
    colors: [
      { name: 'Obsidian', hex: '#2A2A2A' },
      { name: 'Canvas', hex: '#EBE9E1' },
      { name: 'Clay', hex: '#C27C5E' },
      { name: 'Deep Sage', hex: '#4A5D4E' }
    ],
    features: ['24h Cold', '12h Hot', 'Leak-proof']
  },
  {
    id: 'p2',
    name: 'The Commuter Cup',
    subtitle: '20oz | Slim-Fit Design',
    price: 32,
    category: 'bottles',
    collection: 'Urban Series',
    image: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?q=80&w=800&auto=format&fit=crop',
    colors: [
      { name: 'Canvas', hex: '#EBE9E1' },
      { name: 'Obsidian', hex: '#2A2A2A' }
    ],
    features: ['Cup-holder ready', 'Splash-proof', 'Ergonomic']
  },
  {
    id: 'p3',
    name: 'The Trail Kit',
    subtitle: 'Flask + Sport Cap + Bumper',
    price: 58,
    originalPrice: 68,
    category: 'bundles',
    collection: 'Adventure',
    image: 'https://images.unsplash.com/photo-1523362628745-0c14fbfa5bf2?q=80&w=800&auto=format&fit=crop',
    colors: [],
    features: ['Adventure-ready', 'Impact protection', 'High-flow']
  }
];

export const comparisonData = [
  { feature: 'Body Material', terra: '18/8 Recycled Steel', standard: 'Virgin Stainless Steel' },
  { feature: 'Insulation', terra: 'Triple-Wall Vacuum', standard: 'Double-Wall' },
  { feature: 'End-of-life', terra: 'Refill-Loop Recyclable', standard: 'Landfill / Downcycle' },
  { feature: 'Warranty', terra: 'Lifetime Technical', standard: '1-Year Limited' },
  { feature: 'Paint Finish', terra: 'Tough-Grip™ Powder Coat', standard: 'Standard Enamel' }
];

export const reviews = [
  {
    id: 1,
    author: 'Marcus R.',
    location: 'Denver, CO',
    text: "The build quality is noticeably better than the big-name brands. The Clay finish is gorgeous and hasn't chipped after a month of heavy commuting.",
    rating: 5
  },
  {
    id: 2,
    author: 'Elena S.',
    location: 'Seattle, WA',
    text: "Finally, a brand that actually wants to help me repair my gear instead of just selling me a new bottle. The replacement cap system is genius.",
    rating: 5
  },
  {
    id: 3,
    author: 'Julian K.',
    location: 'Austin, TX',
    text: "Used the Refill-Loop to trade in my old dented bottle. The process was seamless and I love my new Commuter Cup.",
    rating: 4
  }
];

export const faqs = [
  {
    q: 'How does the Refill-Loop program work?',
    a: 'When your TerraSip bottle reaches the end of its life (or if you just want an upgrade), send it back to us using the pre-paid label in your account. We dismantle, recycle, and refurbish the parts. You get 20% off your next order.'
  },
  {
    q: 'Are the bottles dishwasher safe?',
    a: 'The stainless steel bodies are top-rack dishwasher safe, though we recommend hand washing with our Agave Bristle Brush to preserve the powder-coat finish longest. Caps are fully dishwasher safe.'
  },
  {
    q: 'What is your shipping and return policy?',
    a: 'We offer carbon-neutral free shipping on US orders over $50. If you are not 100% satisfied, you can return your unused product within 30 days for a full refund.'
  },
  {
    q: 'Can I buy just a replacement cap?',
    a: 'Yes! We strongly encourage repairing over replacing. You can find replacement caps, seals, and bumpers in our Accessories section.'
  }
];